import React, { useEffect, useState } from 'react';
import RequestAccessModal from 'containers/Authentication/LoginPage/RequestAccessModal';
import logo from '../../animationAssets/adsurefinallogo.png';
import { useDispatch } from 'react-redux';
import { logoutUser } from 'containers/Authentication/actions';

export default function Forbidden403() {
  const [showModal, setShowModal] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const dispatch = useDispatch();

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          dispatch(logoutUser());
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [dispatch]);

  return (
    <div
      style={{
        height: '93vh',
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'sans-serif',
        textAlign: 'center',
        padding: '0 20px',
        position: 'relative',
      }}
    >
      <div>
        <h1 style={{ fontSize: '8rem', margin: 0, color: '#333' }}>403</h1>
        <h2
          style={{
            fontSize: '2rem',
            margin: '10px 0',
            fontWeight: 500,
            color: '#555',
          }}
        >
          Forbidden
        </h2>
        <p style={{ fontSize: '1rem', color: '#777', marginBottom: 8 }}>
          Access to this resource on the server is denied.
        </p>
        <p style={{ fontSize: '1rem', color: '#555' }}>
          If this is your first time here,&nbsp;
          <span
            onClick={() => setShowModal(true)}
            style={{
              color: '#157f95',
              fontWeight: 'bold',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
          >
            request for access
          </span>
        </p>
        <p style={{ fontSize: '0.9rem', color: '#999' }}>
          Redirecting to login in {countdown} second{countdown !== 1 ? 's' : ''}
        </p>
        <button
          onClick={() => dispatch(logoutUser())}
          style={{
            marginTop: 16,
            padding: '10px 20px',
            fontSize: '1rem',
            backgroundColor: '#157f95',
            color: '#fff',
            border: 'none',
            borderRadius: 5,
            cursor: 'pointer',
          }}
        >
          Go to Login Page
        </button>
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: 30,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 10,
        }}
      >
        <img
          src={logo}
          alt="Web Portal Logo"
          style={{ width: 120, height: 'auto', objectFit: 'contain' }}
        />
        <p style={{ fontSize: '1rem', color: '#555', margin: 0 }}>
          If the issue persists, please contact&nbsp;
          <a
            href="mailto:adtech.qa@lgads.tv"
            style={{
              color: '#157f95',
              fontWeight: 'bold',
              textDecoration: 'none',
            }}
          >
            adtech.qa@lgads.tv
          </a>
        </p>
      </div>

      <RequestAccessModal show={showModal} onHide={() => setShowModal(false)} />
    </div>
  );
}
